// Modal Names
export const MODAL_DELETE_CONTACT = "contact-archive";
export const MODAL_ARCHIVE_PROPERTY = "property-archive";
export const MODAL_ARCHIVE_UNIT = "unit-delete";
export const MODAL_DELETE_FILE = "file-delete";
export const MODAL_IMAGE_VIEW = "image-view";

export const MODAL_LEASE_RENEW = "lease-renew";
export const MODAL_LEASE_END = "lease-end";
export const MODAL_ARCHIVE_LEASE = "lease-archive";

export const MODAL_LEAD_REQUEST = "lead-request";

export const MODAL_RATE_US = "rate-us";
